import type { ReactNode } from "react";

function emptyToNull(str: unknown): string | null {
  if (typeof str === "string" && str !== "") {
    return str;
  }

  return null;
}

type GetHelperTextParams = {
  helperText: string | ReactNode;
  errorMessage: string | undefined;
  warningMessage: string | undefined;
  readOnly: boolean | undefined;
};

export function getHelperText({
  helperText,
  errorMessage,
  warningMessage,
  readOnly,
}: GetHelperTextParams): string | ReactNode {
  if (readOnly === true) {
    return transformHelper(helperText);
  }

  if (typeof errorMessage === "string" && errorMessage !== "") {
    return errorMessage;
  }

  if (typeof warningMessage === "string" && warningMessage !== "") {
    return warningMessage;
  }

  return transformHelper(helperText);
}

function transformHelper(helper: string | ReactNode) {
  return typeof helper === "string" ? emptyToNull(helper) : helper;
}
